export const Pillar = (target: HTMLLabelElement) => {

  const el = {
    root: target,
    input: target.querySelector<HTMLInputElement>('.pillar__input'),
  }

  const method = {

    init: () => {
      if (!el.root || !el.input) return
      el.input.addEventListener('change', method.onChange)
    },

    onChange: (e: Event & { target: HTMLInputElement }) => {
      if (!e.target.checked) return
      method.resetPillars()
      el.root.classList.add('pillar--selected')
    },

    resetPillars: () => {
      let pillarGroup = el.root.parentElement as HTMLElement;

      // if pillar is wrapped in li tag we have to target its parent
      if (!pillarGroup.classList.contains('pillar-group')) {
        pillarGroup = pillarGroup.parentElement
      }

      if (!pillarGroup.classList.contains('pillar-group')) return

      const selectedPillars = pillarGroup.querySelectorAll<HTMLDivElement>('.pillar--selected')
      selectedPillars.forEach(item => item.classList.remove('pillar--selected'))
    },
  }

  method.init()
}